import * as React from 'react';
import { Product as IProduct } from '../models/interfaces';
import Product from './Product';

export interface ProductListProps {
  products: IProduct[];
  addProduct: (product: IProduct, amount: number) => void;
  layout: {
    showPictures: boolean,
    largeProducts: boolean,
    showItemNo: boolean,
    showWeightInput: boolean
  };
  totalWeight: string;
}

class ProductList extends React.Component<ProductListProps> {
  hasProducts: boolean;

  constructor(props: ProductListProps) {
    super(props);
    this.hasProducts = false;

    if (props.products.length !== 0) {
      this.hasProducts = true;
    }
  }

  getProducts() {
    const {
      products,
      addProduct,
      layout,
      totalWeight
    } = this.props;

    if (products.length) {
      return products.sort((a, b) => {
        if (a.Description < b.Description) {
          return -1;
        }
        if (a.Description > b.Description) {
          return 1;
        }
        return 0;
      }).map(product =>
        (
          <Product
            key={product.Key}
            product={product}
            addProduct={addProduct}
            showItemNo={layout.showItemNo}
            showImage={layout.showPictures}
            totalWeight={totalWeight}
            showWeightInput={layout.showWeightInput}
          />
        )
      );
    }

    return <div className="empty">Tuotteita ei löytynyt</div>;
  }

  getClassName() {
    const { layout } = this.props;
    let className = 'product-list condensed';

    if (layout.largeProducts) {
      className += ' product-list--large';
    } else {
      className += ' product-list--table';
    }

    if (layout.showPictures) {
      className += ' product-list--image';
    }

    return className;
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {
          this.getProducts()
        }
      </div>
    );
  }
}

export default ProductList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProductList.tsx